import { Coins } from "lucide-react";
import { useEffect, useRef, useState } from "react";
import { useSettings } from "../contexts/SettingsContext";

export function TokenCounter({ value, testId = "token-counter" }) {
  const { reducedMotion } = useSettings();
  const [pulse, setPulse] = useState(false);
  const prev = useRef(value);

  useEffect(() => {
    if (prev.current !== value && !reducedMotion) {
      setPulse(true);
      const t = setTimeout(() => setPulse(false), 300);
      prev.current = value;
      return () => clearTimeout(t);
    }
    prev.current = value;
  }, [value, reducedMotion]);

  return (
    <div
      className={`wmleye-tokencounter${pulse ? " wmleye-tokencounter--pulse" : ""}`}
      data-testid={testId}
      aria-label={`Token balance ${value}`}
    >
      <Coins size={18} aria-hidden />
      <span className="wmleye-tokencounter__value" data-testid={`${testId}-value`}>
        {value}
      </span>
    </div>
  );
}
